import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../store/AuthContext';
import {
  canAccessModule,
  getFirstAllowedRoute,
  getModuleForPath,
  getResolvedPermissions,
} from '../utils/adminPermissions';

const RoleRoute: React.FC<{ children: React.ReactElement }> = ({ children }) => {
  const { authState } = useAuth();
  const location = useLocation();
  const permissions = getResolvedPermissions(authState);

  if (!authState.token) {
    return <Navigate to="/" replace />;
  }

  const moduleName = getModuleForPath(location.pathname);
  const fallback = getFirstAllowedRoute(permissions);
  const isEditScreen =
    location.pathname.includes('/add-product') ||
    location.pathname.includes('/products/edit') ||
    location.pathname.includes('/manage/services/create') ||
    location.pathname.includes('/bookings/create') ||
    location.pathname.includes('/bookings/edit');

  if (isEditScreen && !canAccessModule(permissions, moduleName, 'edit')) {
    if (location.pathname === fallback) return children;
    return <Navigate to={fallback} replace />;
  }

  if (!canAccessModule(permissions, moduleName, 'view')) {
    if (location.pathname === fallback) return children;
    return <Navigate to={fallback} replace />;
  }

  return children;
};

export default RoleRoute;
